import React, { useEffect, useRef, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './form-wizard.less';

const FormWizard = ({
	isLoading,
	activeStep,
	steps,
	styles = {},
	topStaticElement,
	bottomStaticElement,
	disableSwipe,
	setForceUpdateHeight,
	forceUpdateHeight = false,
	isElementVisible = true,
	isLinearProgressVisible = true,
}) => {
	const { progress, paper, container } = styles;
	const [completed, setCompleted] = useState(1);
	const swipeableViewsRef = useRef();

	useEffect(() => {
		if (forceUpdateHeight) {
			swipeableViewsRef.current.updateHeight();
			setForceUpdateHeight(false);
		}
		return () => {
			if (swipeableViewsRef.current) {
				swipeableViewsRef.current = null;
			}
		};
	}, [forceUpdateHeight, setForceUpdateHeight]);

	useEffect(() => {
		setCompleted(((activeStep + 1) * 100) / steps.length);
	}, [steps, activeStep]);

	return (
		<div className="form-wizard">
			{isLinearProgressVisible && (
				<LinearProgress
					variant={isLoading ? undefined : 'determinate'}
					value={isLoading ? undefined : completed}
					className={progress}
					classes={{ root: 'form-wizard-linear-progress' }}
				/>
			)}
			<Paper
				className={paper}
				disabled={isLoading}
				style={{ position: 'relative' }}
				classes={{ root: 'form-wizard-paper' }}
				id="totango-signup-wrapper"
			>
				<div className={classNames('step-overlay', isLoading ? 'active' : '')} />
				{isElementVisible && topStaticElement}
				<SwipeableViews
					ref={swipeableViewsRef}
					className="swipeable-views-form-wizard"
					style={container}
					index={activeStep}
					animateHeight
					disabled={disableSwipe}
				>
					{steps}
				</SwipeableViews>
				{bottomStaticElement}
			</Paper>
		</div>
	);
};
FormWizard.defaultProps = {
	isLoading: false,
	topStaticElement: null,
	bottomStaticElement: null,
	disableSwipe: false,
	isElementVisible: true,
	isLinearProgressVisible: true,
};

FormWizard.propTypes = {
	isLoading: PropTypes.bool,
	activeStep: PropTypes.number.isRequired,
	steps: PropTypes.array.isRequired,
	topStaticElement: PropTypes.element,
	bottomStaticElement: PropTypes.element,
	disableSwipe: PropTypes.bool,
	isElementVisible: PropTypes.bool,
	isLinearProgressVisible: PropTypes.bool,
};

export default FormWizard;
